<template>
    <div class="player-card" :class="{ 'player-card--unavailable': reasons.length, 'player-card--clickable': clickable }" @click="$emit('click')">
        <div class="player-card__jersey" :style="{ backgroundColor: color, color: textColor }">{{ jersey }}</div>
        <div class="player-card__photo">
            <v-icon color="grey"> mdi-account </v-icon>
        </div>
        <div class="player-card__info">
            <div class="player-card__name">{{ player.name }}</div>
            <div class="player-card__surname">{{ player.surname }}</div>
            <div v-if="reasons.length" class="player-card__reason">
                <v-icon x-small color="red"> mdi-alert-circle </v-icon>
                {{ reasons.join(', ') }}
            </div>
        </div>
        <div class="player-card__actions" @click.stop>
            <slot />
        </div>
    </div>
</template>

<script>
    // One player in the stats dialogs (roster, substitutions, pick a player)
    export default {
        name: 'StatsPlayerRow',
        props: {
            player: {
                type: Object,
                required: true
            },
            jersey: {
                type: [Number, String],
                default: ''
            },
            color: {
                type: String,
                default: '#000000'
            },
            textColor: {
                type: String,
                default: '#ffffff'
            },
            reasons: {
                type: Array,
                default: () => []
            },
            clickable: {
                type: Boolean,
                default: false
            }
        }
    }
</script>

<style scoped>
    .player-card {
        display: flex;
        align-items: center;
        gap: 10px;
        padding-right: 8px;
        border-radius: 12px;
        background: #fff;
        box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12);
        overflow: hidden;
        text-align: left;
    }
    .player-card--clickable {
        cursor: pointer;
        user-select: none;
        transition: transform 0.08s, box-shadow 0.08s;
    }
    .player-card--clickable:active {
        transform: scale(0.98);
        box-shadow: 0 0 0 2px #009688;
    }
    .player-card__jersey {
        display: flex;
        align-items: center;
        justify-content: center;
        align-self: stretch;
        min-width: 44px;
        padding: 0 4px;
        font-size: 20px;
        font-weight: 800;
        font-variant-numeric: tabular-nums;
    }
    .player-card__photo {
        display: flex;
        align-items: center;
        justify-content: center;
        flex-shrink: 0;
        width: 40px;
        height: 52px;
        margin: 6px 0;
        border-radius: 8px;
        overflow: hidden;
        background: #eeeeee;
    }
    .player-card__info {
        flex: 1;
        min-width: 0;
        line-height: 1.2;
    }
    .player-card__name {
        font-size: 14px;
        font-weight: 700;
        overflow-wrap: anywhere;
    }
    .player-card__surname {
        font-size: 13px;
        color: rgba(0, 0, 0, 0.6);
        overflow-wrap: anywhere;
    }
    .player-card__reason {
        margin-top: 2px;
        font-size: 11px;
        font-weight: 600;
        color: #e53935;
    }
    .player-card__actions {
        display: flex;
        align-items: center;
        flex-shrink: 0;
    }
    .player-card--unavailable .player-card__photo,
    .player-card--unavailable .player-card__jersey {
        opacity: 0.45;
    }
</style>
